import React, { Component } from 'react';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import apiFetch from './services/ApiClient'; // adjust path if your ApiClient is elsewhere

export class ForgotPassword extends Component {
    static displayName = ForgotPassword.name;

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            submitting: false,
            sent: false,
            error: null
        };
    }

    submit = async () => {
        this.setState({ submitting: true, error: null });

        try {
            const r = await apiFetch('/api/Account/ForgotPassword', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: this.state.email })
            });

            // Your apiFetch wrapper returns { status, data }
            if (r.status !== 200) {
                this.setState({ submitting: false, error: 'Request failed.' });
                return;
            }

            // Always show "sent" even if email doesn't exist (anti-enumeration)
            this.setState({
                submitting: false,
                sent: true
            });
        } catch (e) {
            this.setState({ submitting: false, error: String(e) });
        }
    }

    render() {
        const logo = {
            width: '250px',
            padding: '1.5em',
            margin: '20px auto',
            display: 'block'
        };

        return (
            <Container>
                <Row style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'></Col>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'>
                        <div>
                            <img src="logo.jpg" alt="logo" style={logo} />
                        </div>

                        {!this.state.sent ? (
                            <>
                                <p>
                                    Enter your email. If it exists in our system, we will send a password reset link.
                                </p>

                                <Input
                                    type='text'
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    name='email'
                                    id='email'
                                    placeholder='Email Address'
                                />
                                <br />
                                <Button
                                    color='primary'
                                    disabled={this.state.submitting || !this.state.email}
                                    onClick={this.submit}
                                >
                                    {this.state.submitting ? 'Submitting...' : 'Submit'}
                                </Button>

                                {this.state.error && (
                                    <div style={{ marginTop: 12, color: 'crimson', textAlign: 'left' }}>
                                        {this.state.error}
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <p>
                                    If the email exists, a reset link has been sent.
                                </p>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}
